module.exports = __webpack_public_path__ + "img/meeting_planner_900px_svhv.73173dc6.jpg";